import { Text } from 'components';
import { useTranslation } from 'react-i18next';
import { TableComponents } from 'screens/Admin/components';
import ListItem from './ListItem';

const { List: TableList, Th } = TableComponents;

const List = ({ data, dataId, onClick, onSync, syncingId, loading }) => {
  const { t } = useTranslation();

  return (
    <TableList
      loading={loading}
      Header={() => (
        <>
          <Th first>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.country')}</Text>
          </Th>
          <Th>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.title')}</Text>
          </Th>
          <Th>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.monthly')}</Text>
          </Th>
          <Th>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.yearly')}</Text>
          </Th>
          <Th>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.currency')}</Text>
          </Th>
          <Th>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.sync')}</Text>
          </Th>
          <Th last>
            <Text size="11px" weight="700" col="#7989A0">{t('subscription.admin.table.status')}</Text>
          </Th>
        </>
      )}
      Items={() =>
        data?.map((plan) => (
          <ListItem
            key={plan._id}
            plan={plan}
            isSelected={dataId === plan._id}
            onClick={onClick}
            onSync={onSync}
            syncingId={syncingId}
          />
        ))
      }
    />
  );
};

export default List;
